import axios from 'axios';
import { PointOfSaleModel } from '../models/PointOfSaleModel';

const API_URL = process.env.REACT_APP_API_URL;
const POINTS_OF_SALE_URL = `${API_URL}/api/b2b/points-of-sale/`;

export function listPointsOfSale(params?: {
  distributor?: number;
  shop?: number;
}): Promise<{ data: Array<PointOfSaleModel> }> {
  return axios.get(POINTS_OF_SALE_URL, { params: params || {} });
}

export function createPointOfSale(
  pointOfSale: Pick<PointOfSaleModel, 'distributor' | 'shop'>
): Promise<{ data: PointOfSaleModel }> {
  return axios.post(POINTS_OF_SALE_URL, pointOfSale);
}

export function updatePointOfSale(
  pointOfSale: Pick<PointOfSaleModel, 'distributor' | 'shop'> & { id: number }
): Promise<{ data: PointOfSaleModel }> {
  return axios.patch(`${POINTS_OF_SALE_URL}${pointOfSale.id}/`, {
    distributor: pointOfSale.distributor,
    shop: pointOfSale.shop,
  });
}

export function deletePointOfSale(id: number): Promise<{ data: void }> {
  return axios.delete(`${POINTS_OF_SALE_URL}${id}/`);
}
